PJQ.views.bidForms.BidFormViewer = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-BidForm'),
        subTemplates: {
            lineItem: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Group-LineItem'),
            alternate: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Group-Alternate'),
            groupAcknowledgement: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Group-Acknowledgement'),
            projectAcknowledgement: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Project-Acknowledgement'),
            bonding: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Project-Bonding'),
            certification: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Project-Certification'),
            laborRate: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Project-Labor-Rate'),
            itemInput: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'BidForm-Item-Input'),
            bidder: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Bidder')
        },
        isEdit: true,
        onEditChange: _.noop
    },
    events: {
        "click .add-group-line-item-button": "newGroupLineItem",
        "click .add-group-alternate-button": "newGroupAlternate",
        "change .group-line-item-type": "groupLineItemChanged",
        "keyup .group-line-item-description,.group-line-item-cost-dollars,.group-line-item-cost-cents,.group-line-item-multiplier": "groupLineItemChanged",
        "click .delete-group-line-item-button": "deleteGroupLineItem",
        "change .group-alternate-type": "groupAlternateChanged",
        "keyup .group-alternate-description,.group-alternate-cost-dollars,.group-alternate-cost-cents,.group-alternate-multiplier": "groupAlternateChanged",
        "click .delete-group-alternate-button": "deleteGroupAlternate",
        "keydown .bid-form-item-numeric": "numbersOnly",
        "keydown .bid-form-item-numeric-negative": "numbersOnlyNegative",
        "keydown .line-item-multiplier,.alternate-multiplier": "numbersAndSingleDecimalOnly",
        "keyup .bid-form-inclusions": "inclusionsChanged",
        "keyup .bid-form-exclusions": "exclusionsChanged",
        "click .bid-form-attachment-download": "downloadAttachment",
        "click .bid-form-additional-document-download": "downloadAdditionalBidDocument",
        "keyup .bid-form-notes": "notesChanged",
        "click .bid-form-lock": "setLocked",
        "click .bid-form-reject": "reject",
        "click .bid-form-submit": "submit",
        "click .bid-form-award": "award",
        "click .bid-form-unaward": "unaward",
        "click .bid-form-save": "save",
        "click .bid-form-edit": "edit",
        "click .proposal-export-xlsx": "exportProposalExcelClicked",
        "click .proposal-export-all-xlsx": "exportProposalWithAttachmentsExcelClicked",
        "click .proposal-export-pdf": "exportProposalPDFClicked",
        "click .proposal-export-all-pdf": "exportProposalWithAttachmentsPDFClicked",
        "click .proposal-export-attachments": "exportAttachments",
        "click .bid-form-compare": "compare",
        "click .bid-form-cancel-edit": "cancelEdit",
        'click .bidder-edit': 'editBidder',
    },
    beforeFirstRender: function () {
        this.options.canEdit = PJQ.app.session.project.hasPermission('bidForms.isAdmin') || PJQ.app.session.project.get('masterUserId') !== PJQ.app.session.get('masterUserId');
        this.options.isAdmin = PJQ.app.session.user != null && PJQ.app.session.project.hasPermission('bidForms.isAdmin') && PJQ.app.session.project.get('masterUserId') === PJQ.app.session.user.get('masterUserId');

        if (this.options.projectBidForm) {
            this.projectBidForm = this.options.projectBidForm;
            this.listenTo(this.projectBidForm, "sync", this.render);
            this.listenTo(this.projectBidForm, "change", this.changed);
            this.listenTo(this.projectBidForm.acknowledgements, "change", this.changed);
            this.listenTo(this.projectBidForm.bonding, "change", this.changed);
            this.listenTo(this.projectBidForm.certifications, "change", this.changed);
            this.listenTo(this.projectBidForm.laborRates, "change", this.changed);
        }

        if (this.model) {
            this.listenTo(this.model, "sync", this.render);
            this.listenTo(this.model, "change", this.changed);
            this.listenTo(this.model.lineItems, "change", this.changed);
            this.listenTo(this.model.alternates, "change", this.changed);
            this.listenTo(this.model.acknowledgements, "change", this.changed);
        }

        if (this.options.settings == null) {
            PJQ.app.session.project.fetchBidFormSettings(_.bind(function (settings) {
                this.options.settings = settings;
                this.render();
            }, this));
        }
    },
    beforeRender: function () {
        this.options.isEdit = this.options.isEdit && !this.model.get('isLocked');
        this.options.onEditChange(this.options.isEdit);
        if (this.model != null && this.model instanceof PJQ.models.bidForms.Proposal) {
            let dialogDeleteButton = this.$el.closest('.modal-content').find('.proposal-delete');
            if (dialogDeleteButton != null) {
                dialogDeleteButton.off().on('click', _.bind(function () {
                    this.deleteProposal();
                }, this))
            }
        }
    },
    renderData: function () {
        return {
            model: this.model,
            isShowErrors: this.options.isShowErrors,
            canEdit: this.options.canEdit,
            isAdmin: this.options.isAdmin,
            projectBidForm: this.projectBidForm,
            settings: this.options.settings,
            collection: this.collection,
            proposals: this.collection != null ? this.collection.getProposals(this.model.get('bidFormId')) : [],
            isEdit: this.options.isEdit,
            requireAttachments: !this.options.isAdmin && this.options.settings.get('isRequireAttachment')
        };
    },
    afterRender: function () {
        if (this.options.settings == null) {
            return;
        }

        if (this.options.isAdmin) {
            this.renderBidderInfo();
        }

        this.renderGroupLineItems();

        this.renderGroupAlternates();

        this.renderAdditionalBidDocuments();

        _.each(_.sortBy(this.model.acknowledgements.models, function (ack) {
            return ack.get('sortOrder');
        }), _.bind(function (acknowledgement) {
            this.renderGroupAcknowledgement(acknowledgement);
        }, this));

        _.each(_.sortBy(this.projectBidForm.acknowledgements.models, function (bond) {
            return bond.get('sortOrder');
        }), _.bind(function (acknowledgement) {
            this.renderProjectAcknowledgement(acknowledgement);
        }, this));

        _.each(this.projectBidForm.bonding.models, _.bind(function (bonding) {
            this.renderProjectBonding(bonding);
        }, this));

        _.each(_.sortBy(this.projectBidForm.certifications.models, function (cert) {
            return cert.get('sortOrder');
        }), _.bind(function (certification) {
            this.renderProjectCertification(certification);
        }, this));

        _.each(_.sortBy(this.projectBidForm.laborRates.models, function (labor) {
            return labor.get('sortOrder');
        }), _.bind(function (laborRate) {
            this.renderProjectLaborRate(laborRate);
        }, this));

        if (this.options.isEdit) {
            this.fileUploader = new PJQ.views.files.FileUploaderGrid({
                el: this.$('.bid-form-file-upload'),
                useBlob: true,
                collection: this.model.attachments,
                endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                    {
                        endpoint: 'projects',
                        value: PJQ.app.session.project.id
                    },
                    {
                        endpoint: 'proposals',
                        value: this.model.get('proposalId')
                    },
                    {
                        endpoint: 'attachments'
                    }
                ]),
                onDrop: _.bind(function () {
                    this.changed();
                }, this),
                onDelete: _.bind(function (attachment, callback) {
                    this.changed();
                    if (attachment.id > 0) {
                        attachment.set('isDeleted', true);
                    } else {
                        attachment.destroy();
                    }
                    this.model.isDirty = true;
                    callback();
                }, this)
            });

            if (this.options.hasFileError) {
                this.fileUploader.showError("You must attach all requested bid documents before submitting.", null);
            }
        }

        this.options.isShowErrors = false;
    },
    renderAdditionalBidDocuments: function () {

    },
    renderBidderInfo: function () {
        if (this.options.isAdmin && this.model.bidder != null) {
            this.renderSubTemplate(false, this.options.subTemplates.bidder, this.$el.closest('.modal-content').find('.bid-form-bidder-info'), {
                bidder: this.model.bidder,
                canEdit: this.options.canEdit,
                colClass: 'col-lg-6 col-sm-12',
                isShowDelete: false,
                isShowBidStatus: false
            });
        }
    },
    editBidder: function (e) {
        let selectedContact = this.model.bidder.contacts.get($(e.currentTarget).closest('.bidder-contact-container').data('cid'));
        new PJQ.views.contacts.BaseEditContactModal({
            model: selectedContact,
            onSave: _.bind(function () {
                this.model.bidder.set('companyName', selectedContact.get('companyName'));
                this.renderBidderInfo();
            }, this)
        });
    },
    getItemInput: function (model, isEdit) {
        return PJQ.templating.TemplateRenderer.parseTemplate(this.options.subTemplates.itemInput, {
            model: model,
            isEdit: isEdit,
            helpers: PJQ.helpers
        });
    },
    changed: function () {
        this.$('.bid-form-save').prop('disabled', false);
    },
    newGroupLineItem: function () {
        let newLineItem = new PJQ.models.bidForms.LineItem({
                bidFormId: this.model.id,
                isNew: true
            }),
            currentLineItems = this.model.lineItems;
        newLineItem.set('comments', []);
        newLineItem.comments = new PJQ.collections.bidForms.ProposalLineItemComments();
        currentLineItems.add(newLineItem);
        this.model.set('lineItems', currentLineItems);
        this.renderGroupLineItems();
    },
    renderGroupLineItems: function () {
        this.$('.bid-form-group-line-items').empty();
        _.each(_.sortBy(_.sortBy(this.model.lineItems.models, function (lineItem) {
            return lineItem.get('sortOrder');
        }), function (lineItem) {
            return lineItem.get('contactCompanyId');
        }), _.bind(function (lineItem) {
            this.renderGroupLineItem(lineItem);
        }, this));
    },
    renderGroupLineItem: function (lineItem) {
        let category = lineItem.get('category'),
            $outer = this.$('.bid-form-group-line-items'),
            $container;
        if (_.size(category) > 0) {
            $container = $outer.find('.line-item-category[data-category="' + category + '"]>.line-items');
            if ($container.length === 0) {
                let subtotal = 0;
                _.each(_.filter(this.model.lineItems.models, function (item) {
                    return item.get('category') === category
                }), function (item) {
                    subtotal += item.calculateTotal();
                });
                $outer.append('<div class="line-item-category mt-2" data-category="' + category + '"><div class="fs-16 font-weight-medium">' + category + '</div><div class="line-items ml-2"></div><div class="subtotal-outer ml-2 mb-2"></div></div>');

                let $category = $outer.find('.line-item-category[data-category="' + category + '"]');
                $container = $category.find('.line-items');

                let $subtotal = $category.find('.subtotal-outer');
                $subtotal.append('<div><div class="row border-top border-muted fs-16 pt-2"><div class="offset-7 col-2 text-align-right font-weight-medium">Subtotal:</div><div class="col-2 text-align-center no-padding-right subtotal">' + PJQ.helpers.formatHelpers.formatCurrency(subtotal) + '</div></div></div>');
            }
        } else {
            $container = $outer;
        }

        let data = {
            item: lineItem,
            isEdit: this.options.isEdit,
            subTotal: PJQ.helpers.formatHelpers.formatCurrency(lineItem.calculateTotal()),
            formatHelpers: PJQ.helpers.formatHelpers,
            getItemInput: _.bind(this.getItemInput, this),
            isError: this.options.isShowErrors && lineItem.get('isRequired') && (lineItem.get('cost') == null || (lineItem.get('type').toLowerCase() !== "sum" && lineItem.get('multiplier') == null)),
            canViewComments: PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments')
        };
        this.renderSubTemplate(true, this.options.subTemplates.lineItem, $container, data, _.bind(function (content) {
            this.attachItemEvents(content, lineItem, _.bind(function (value) {
                this.updateBidFormItem(lineItem, value);
            }, this));
        }, this));
    },
    groupLineItemChanged: function (e) {
        let row = $(e.currentTarget).closest('.group-line-item-row'),
            cid = row.data('cid'),
            costDollars = row.find('.group-line-item-cost-dollars').val(),
            costCents = row.find('.group-line-item-cost-cents').val(),
            multiplier = row.find('.group-line-item-multiplier').val(),
            descriptionInput = row.find('.group-line-item-description'),
            typeInput = row.find('.group-line-item-type'),
            model = this.model.lineItems.get({cid: cid});

        if (costDollars.length > 0 && costCents.length === 0) {
            costCents = '00';
        } else if (costDollars.length === 0 && costCents.length > 0) {
            costDollars = '0';
        }

        model.set({
            cost: costDollars.length === 0 && costCents.length === 0 ? null : PJQ.helpers.formatHelpers.getTotalCents(costDollars, costCents),
            multiplier: isNaN(multiplier) ? 0 : multiplier
        });

        this.calculateLineItemSubtotal(e);

        if (descriptionInput.length > 0 && typeInput.length > 0) {
            let type = typeInput.val();
            model.set('description', descriptionInput.val());
            if (model.get('type') !== type) {
                if (type.toLowerCase() === 'sum')
                    model.set('multiplier', 0);
                model.set('type', type);

                this.renderGroupLineItems();
            }
        }
    },
    deleteGroupLineItem: function (e) {
        let cid = $(e.currentTarget).closest('.group-line-item-row').data('cid');
        this.model.updateLineItemDeleted(cid, true);
        $(e.currentTarget).closest('.group-line-item-row').remove();
    },
    newGroupAlternate: function () {
        let newAlternate = new PJQ.models.bidForms.Alternate({
                bidFormId: this.model.id,
                isNew: true
            }),
            currentAlternates = this.model.alternates;
        newAlternate.set('comments', []);
        newAlternate.comments = new PJQ.collections.bidForms.ProposalAlternateComments();
        currentAlternates.add(newAlternate);
        this.model.set('alternates', currentAlternates);
        this.renderGroupAlternate(newAlternate);
    },
    renderGroupAlternates: function () {
        this.$('.bid-form-group-alternates').empty();
        _.each(_.sortBy(this.model.alternates.models, function (alternate) {
            return alternate.get('sortOrder');
        }), _.bind(function (alternate) {
            this.renderGroupAlternate(alternate);
        }, this));
    },
    renderGroupAlternate: function (alternate) {
        let category = alternate.get('category'),
            $outer = this.$('.bid-form-group-alternates'),
            $container;
        if (_.size(category) > 0) {
            $container = $outer.find('.alternate-category[data-category="' + category + '"]>.alternates');
            if ($container.length === 0) {
                let subtotal = 0;
                _.each(_.filter(this.model.alternates.models, function (alternate) {
                    return alternate.get('category') === category
                }), function (alternate) {
                    subtotal += alternate.calculateTotal();
                });
                $outer.append('<div class="alternate-category mt-2" data-category="' + category + '"><div class="fs-16 font-weight-medium">' + category + '</div><div class="alternates ml-2"></div><div class="subtotal-outer ml-2 mb-2"></div></div>');

                let $category = $outer.find('.alternate-category[data-category="' + category + '"]');
                $container = $category.find('.alternates');

                let $subtotal = $category.find('.subtotal-outer');
                $subtotal.append('<div><div class="row border-top border-muted fs-16 pt-2"><div class="offset-7 col-2 text-align-right font-weight-medium">Subtotal:</div><div class="col-2 text-align-center subtotal no-padding-right subtotal">' + PJQ.helpers.formatHelpers.formatCurrency(subtotal) + '</div></div></div>');
            }
        } else {
            $container = $outer;
        }

        let data = {
            item: alternate,
            isEdit: this.options.isEdit,
            subTotal: PJQ.helpers.formatHelpers.formatCurrency(alternate.calculateTotal()),
            formatHelpers: PJQ.helpers.formatHelpers,
            getItemInput: _.bind(this.getItemInput, this),
            isError: this.options.isShowErrors && alternate.get('isRequired') && (alternate.get('cost') == null || (alternate.get('type').toLowerCase() !== "sum" && alternate.get('multiplier') == null)),
            canViewComments: PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments')
        };
        this.renderSubTemplate(true, this.options.subTemplates.alternate, $container, data, _.bind(function (content) {
            this.attachItemEvents(content, alternate, _.bind(function (value) {
                this.updateBidFormItem(alternate, value);
            }, this));
        }, this));
    },
    groupAlternateChanged: function (e) {
        let row = $(e.currentTarget).closest('.group-alternate-row'),
            cid = row.data('cid'),
            costDollars = row.find('.group-alternate-cost-dollars').val(),
            costCents = row.find('.group-alternate-cost-cents').val(),
            multiplier = row.find('.group-alternate-multiplier').val(),
            descriptionInput = row.find('.group-alternate-description'),
            typeInput = row.find('.group-alternate-type'),
            model = this.model.alternates.get({cid: cid});

        if (costDollars.length > 0 && costCents.length === 0) {
            costCents = '00';
        } else if (costDollars.length === 0 && costCents.length > 0) {
            costDollars = '0';
        }

        model.set({
            cost: costDollars.length === 0 && costCents.length === 0 ? null : PJQ.helpers.formatHelpers.getTotalCents(costDollars, costCents),
            multiplier: isNaN(multiplier) ? 0 : multiplier
        });

        this.calculateAlternateSubtotal(e);

        if (descriptionInput.length > 0 && typeInput.length > 0) {
            let type = typeInput.val();
            model.set('description', descriptionInput.val());
            if (model.get('type') !== type) {
                if (type.toLowerCase() === 'sum')
                    model.set('multiplier', 0);
                model.set('type', type);

                this.renderGroupAlternates();
            }
        }
    },
    deleteGroupAlternate: function (e) {
        let cid = $(e.currentTarget).closest('.group-alternate-row').data('cid');
        this.model.updateAlternateDeleted(cid, true);
        $(e.currentTarget).closest('.group-alternate-row').remove();
    },
    renderGroupAcknowledgement: function (acknowledgement) {
        let category = acknowledgement.get('category'),
            $outer = this.$('.bid-form-acknowledgements'),
            $container;
        if (_.size(category) > 0) {
            $container = $outer.find('.acknowledgement-category[data-category="' + category + '"]>.acknowledgements');
            if ($container.length === 0) {
                $outer.append('<div class="acknowledgement-category mt-2" data-category="' + category + '"><div class="fs-16 font-weight-medium">' + category + '</div><div class="acknowledgements ml-2"></div></div>');

                let $category = $outer.find('.acknowledgement-category[data-category="' + category + '"]');
                $container = $category.find('.acknowledgements');
            }
        } else {
            $container = $outer;
        }

        let data = {
            item: acknowledgement ? acknowledgement : new PJQ.models.bidForms.Acknowledgement(),
            isEdit: this.options.isEdit,
            getItemInput: _.bind(this.getItemInput, this)
        };
        this.renderSubTemplate(true, this.options.subTemplates.groupAcknowledgement, $container, data, _.bind(function (content) {
            this.attachItemEvents(content, acknowledgement, _.bind(function (value) {
                this.updateBidFormItem(acknowledgement, value);
            }, this));
        }, this));
    },
    renderProjectAcknowledgement: function (acknowledgement) {
        let category = acknowledgement.get('category'),
            $outer = this.$('.bid-form-acknowledgements'),
            $container;
        if (_.size(category) > 0) {
            $container = $outer.find('.acknowledgement-category[data-category="' + category + '"]>.acknowledgements');
            if ($container.length === 0) {
                $outer.append('<div class="acknowledgement-category mt-2" data-category="' + category + '"><div class="fs-16 font-weight-medium">' + category + '</div><div class="acknowledgements ml-2"></div></div>');

                let $category = $outer.find('.acknowledgement-category[data-category="' + category + '"]');
                $container = $category.find('.acknowledgements');
            }
        } else {
            $container = $outer;
        }

        let data = {
            item: acknowledgement ? acknowledgement : new PJQ.models.bidForms.Acknowledgement(),
            isEdit: this.options.isEdit,
            getItemInput: _.bind(this.getItemInput, this)
        };
        this.renderSubTemplate(true, this.options.subTemplates.projectAcknowledgement, $container, data, _.bind(function (content) {
            this.attachItemEvents(content, acknowledgement, _.bind(function (value) {
                this.updateBidFormItem(acknowledgement, value);
            }, this));
        }, this));
    },
    renderProjectBonding: function (bonding) {
        let data = {
            item: bonding ? bonding : new PJQ.models.bidForms.Bonding(),
            isEdit: this.options.isEdit,
            getItemInput: _.bind(this.getItemInput, this)
        };
        this.renderSubTemplate(true, this.options.subTemplates.bonding, this.$('.bid-form-bonding'), data, _.bind(function (content) {
            this.attachItemEvents(content, bonding, _.bind(function (value) {
                this.updateBidFormItem(bonding, value);
            }, this));
        }, this));
    },
    renderProjectCertification: function (certification) {
        let data = {
            item: certification ? certification : new PJQ.models.bidForms.Certification(),
            isEdit: this.options.isEdit,
            getItemInput: _.bind(this.getItemInput, this)
        };
        this.renderSubTemplate(true, this.options.subTemplates.certification, this.$('.bid-form-certifications'), data, _.bind(function (content) {
            this.attachItemEvents(content, certification, _.bind(function (value) {
                this.updateBidFormItem(certification, value);
            }, this));
        }, this));
    },
    renderProjectLaborRate: function (laborRate) {
        let data = {
            item: laborRate ? laborRate : new PJQ.models.bidForms.LaborRate(),
            isEdit: this.options.isEdit,
            getItemInput: _.bind(this.getItemInput, this)
        };
        this.renderSubTemplate(true, this.options.subTemplates.laborRate, this.$('.bid-form-labor-rates'), data, _.bind(function (content) {
            this.attachItemEvents(content, laborRate, _.bind(function (value) {
                this.updateBidFormItem(laborRate, value);
            }, this));
        }, this));
    },
    updateBidFormItem: function (model, value) {
        model.set({
            value: value,
            answer: value
        });
    },
    attachItemEvents: function (el, item, callback) {
        let type = item.get('type').toLowerCase(),
            isValid = !item.get('isRequired') ||
                (_.size(item.get('answer')) > 0 || _.size(item.get('cost')) > 0 || _.size(item.get('value')) > 0)
        if (type === 'yes/no' || type.indexOf('choice') !== -1) {
            isValid = _.size(item.get('value')) > 0 || _.size(item.get('answer')) > 0;
            let isMultiple = (type === 'multiple choice'),
                val = item.get('value') != null && _.size(item.get('value')) > 0 ? item.get('value') : item.get('answer');
            selPicker = new PJQ.inputs.Selectpicker({
                el: el.find('.bid-form-item-select'),
                noneSelectedText: 'Select Value',
                isMultiple: isMultiple,
                defaultValue: isMultiple && val != null ? val.split('|') : val,
                onChange: _.bind(function (value) {
                    if (isMultiple && PJQ.helpers.objectHelpers.refinedType(value) === 'array' && value.length > 0) {
                        value = value.join('|');
                    }
                    callback(value);
                }, this)
            });

            if (this.options.isShowErrors && !isValid) {
                selPicker.showError();
            }
        } else if (type === 'date' || type === 'date/time') {
            let date = item.get('answer') != null ? item.get('answer') : item.get('value') != null ? item.get('value') : null,
                isValid = _.size(date) > 0 || date != null;
            if (typeof date === 'object' && date != null) {
                date = type === 'date' ? date.toDateString() : date;
            }
            new PJQ.inputs.Datepicker({
                el: el.find('.bid-form-item-' + type.replace('/', '') + '>.datepicker'),
                datepickerOptions: {
                    format: type === 'date' ? PJQ.helpers.dateHelpers.dateFormats.datePicker.DATE : undefined,
                    defaultDate: date
                },
                onChange: _.bind(function (value) {
                    callback(value);
                }, this)
            });

            if (this.options.isShowErrors && !isValid) {
                let input = el.find('.datepicker');
                PJQ.helpers.inputHelpers.setInputError(input, false);
            }
        } else if (type === 'money') {
            let $money = el.find('.bid-form-item-dollars,.bid-form-item-cents');
            $money.on('change', _.bind(function () {
                let dollarsText = el.find('.bid-form-item-dollars').val(),
                    centsText = el.find('.bid-form-item-cents').val();

                let dollars;
                if (dollarsText.length === 0) {
                    dollars = null;
                } else {
                    dollars = parseInt(dollarsText) * 100;
                }

                let cents;
                if (centsText.length === 0) {
                    cents = null;
                } else {
                    cents = parseInt(centsText);
                }

                let value;
                if (dollars == null && cents == null) {
                    value = null
                } else {
                    value = (dollars > 0 ? dollars : 0) + (cents > 0 ? cents : 0);
                }
                callback(value);
            }, this));
            if (this.options.isShowErrors && !isValid) {
                PJQ.helpers.inputHelpers.setInputError($money, false);
            }
        } else if (type === 'text' || type === 'numeric' || type === 'textarea') {
            el.find('.bid-form-item-input').on('change', function () {
                let value = $(this).val();
                callback(value);
            });
            if (this.options.isShowErrors && !isValid) {
                let input = el.find('.form-control');
                PJQ.helpers.inputHelpers.setInputError(input, false);
            }
        }

        // comments
        if (typeof item.attributes.comments != "undefined") {
            let buttonClass = (item instanceof PJQ.models.bidForms.ProposalLineItem) ? 'btn-line-item-comments' : 'btn-alternate-comments',
                parentIdField = (item instanceof PJQ.models.bidForms.ProposalLineItem) ? 'proposalLineItemId' : 'proposalAlternateId',
                commentIdField = (item instanceof PJQ.models.bidForms.ProposalLineItem) ? 'proposalLineItemCommentId' : 'proposalAlternateCommentId';
            if ((!(item.get(parentIdField) > 0) && !this.options.isEdit) || (item.comments.length == 0 && !PJQ.app.session.project.hasPermission('bidForms.canAddComments'))) {
                el.find('.' + buttonClass).attr('disabled', true);
            } else {
                el.find('.' + buttonClass).off('click').on('click', _.bind(function (event) {
                    new PJQ.views.bidForms.ProposalItemEditModal({
                        item: item,
                        onSave: _.bind(function () {
                            var comments = _.filter(item.comments.models, function (comment) {
                                    return !comment.get('isDeleted');
                                }),
                                $commentButton = el.find('.' + buttonClass),
                                $commentButtonIcon = el.find('.' + buttonClass + ' i'),
                                tooltip = 'No';

                            if (comments.length > 0) {
                                tooltip = comments.length.toString();

                                $commentButton.removeClass('btn-transparent-dark').addClass('btn-light');
                                $commentButtonIcon.removeClass('text-muted').addClass('text-dark');
                            } else {
                                $commentButton.removeClass('btn-light').addClass('btn-transparent-dark');
                                $commentButtonIcon.removeClass('text-dark').addClass('text-muted');
                            }

                            tooltip = tooltip + ' Comment' + (comments.length != 1 ? 's' : '');
                            $commentButton.attr('title', tooltip);

                            // if we're not in edit mode, we have to manually save changes to the comments.
                            if (!this.options.isEdit && _.some(item.comments.models, function (model) {
                                return !model.get(commentIdField) || model.get('isDeleted');
                            })) {
                                item.comments.save({
                                    success: _.bind(function (data) {
                                        item.comments.reset(data);
                                        PJQ.notifications.notify.successNotify({
                                            message: 'Comments updated successfully'
                                        });
                                    }, this),
                                    error: _.bind(function () {
                                        PJQ.notifications.notify.errorNotify({
                                            message: 'Comment update failed'
                                        });
                                    }, this)
                                });
                            }
                        }, this)
                    });
                }, this));
            }
        }
    },
    calculateLineItemSubtotal: function (e) {
        let row = $(e.currentTarget).closest('.group-line-item-row'),
            cid = row.data('cid'),
            lineItem = this.model.lineItems.get(cid);
        row.find('.group-line-item-total').text(PJQ.helpers.formatHelpers.formatCurrency(lineItem.calculateTotal()));
        this.calculateTotal();
    },
    calculateAlternateSubtotal: function (e) {
        let row = $(e.currentTarget).closest('.group-alternate-row'),
            cid = row.data('cid'),
            alternate = this.model.alternates.get(cid);
        row.find('.group-alternate-total').text(PJQ.helpers.formatHelpers.formatCurrency(alternate.calculateTotal()));
        this.calculateTotal();
    },
    calculateTotal: function () {
        let lineItemCategoryTotals = {};
        _.each(this.model.lineItems.models, function (item) {
            let category = item.get('category');
            if (_.size(category) === 0) {
                return;
            } else if (lineItemCategoryTotals[category] == null) {
                lineItemCategoryTotals[category] = 0;
            }
            lineItemCategoryTotals[category] += item.calculateTotal();
        });

        _.each(lineItemCategoryTotals, function (total, category) {
            let $subtotal = $('.line-item-category[data-category="' + category + '"] .subtotal');
            $subtotal.text(PJQ.helpers.formatHelpers.formatCurrency(total));
        });

        let alternateCategoryTotals = {};
        _.each(this.model.alternates.models, function (alternate) {
            let category = alternate.get('category');
            if (_.size(category) === 0) {
                return;
            } else if (alternateCategoryTotals[category] == null) {
                alternateCategoryTotals[category] = 0;
            }
            alternateCategoryTotals[category] += alternate.calculateTotal();
        });

        _.each(alternateCategoryTotals, function (total, category) {
            let $subtotal = $('.alternate-category[data-category="' + category + '"] .subtotal');
            $subtotal.text(PJQ.helpers.formatHelpers.formatCurrency(total));
        });

        this.$('.proposal-total').text(PJQ.helpers.formatHelpers.formatCurrency(this.model.calculateTotal(false, true)));
        this.$('.proposal-total-alt').text(PJQ.helpers.formatHelpers.formatCurrency(this.model.calculateTotal(true, true)));
    },
    numbersOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e);
    },
    numbersOnlyNegative: function (e) {
        return PJQ.helpers.inputHelpers.numbersOnly(e, false, true);
    },
    numbersAndSingleDecimalOnly: function (e) {
        return PJQ.helpers.inputHelpers.numbersAndSingleDecimalOnly(e);
    },
    inclusionsChanged: function () {
        this.model.set('inclusions', this.$('.bid-form-inclusions').val());
    },
    exclusionsChanged: function () {
        this.model.set('exclusions', this.$('.bid-form-exclusions').val());
    },
    notesChanged: function () {
        this.model.set('notes', this.$('.bid-form-notes').val());
    },
    downloadAdditionalBidDocument: function (e) {
        let cid = $(e.currentTarget).closest('.bid-form-additional-document').data('cid'),
            attachment = this.options.settings.additionalBidDocuments.get({cid: cid});
        attachment.download();
    },
    downloadAttachment: function (e) {
        let cid = $(e.currentTarget).closest('.bid-form-attachment').data('cid'),
            attachment = this.model.attachments.get({cid: cid});
        attachment.download();
    },
    exportProposalWithAttachmentsExcelClicked: function () {
        this.exportProposalWithAttachments('xlsx');
    },
    exportProposalWithAttachmentsPDFClicked: function () {
        this.exportProposalWithAttachments('pdf');
    },
    exportProposalWithAttachments: function (format) {
        let canViewComments = PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            isBidLevelingEnabled = false

        if (isBidLevelingEnabled || canViewComments) {
            new PJQ.views.bidForms.ExportModal({
                isBidLevelingEnabled: isBidLevelingEnabled,
                canViewComments: canViewComments,
                onExport: (exportLeveledProposal, exportComments) => {
                    this.exportZip(null, exportLeveledProposal, exportComments, format);
                }
            });
        } else {
            this.exportZip(null, false, false, format);
        }
    },
    exportProposalExcelClicked: function () {
        this.exportProposal('xlsx');
    },
    exportProposalPDFClicked: function () {
        this.exportProposal('pdf');
    },
    exportProposal: function (format) {
        let canViewComments = PJQ.app.session.project.hasPermission('bidForms.canViewComments') && this.options.settings.get('isEnableLineItemComments'),
            isBidLevelingEnabled = PJQ.app.session.project.hasPermission('bidForms.isAdmin');

        if (format?.toLowerCase() === 'pdf') {
            canViewComments = false;
        }

        if (isBidLevelingEnabled || canViewComments) {
            new PJQ.views.bidForms.ExportModal({
                isBidLevelingEnabled: isBidLevelingEnabled,
                canViewComments: canViewComments,
                onExport: (exportLeveledProposal, exportComments) => {
                    this.model.export(exportLeveledProposal, exportComments, format);
                }
            });
        } else {
            this.model.export(false, false, format);
        }
    },
    exportAttachments: function () {
        this.exportZip('attachments');
    },
    exportZip: function (mode, isExportLeveling, isExportComments, format) {
        let params;
        if (_.size(mode) > 0 || isExportLeveling || isExportComments) {
            params = [
                {
                    parameter: 'mode',
                    value: mode
                },
                {
                    parameter: 'leveling',
                    value: isExportLeveling
                },
                {
                    parameter: 'comments',
                    value: isExportComments
                },
                {
                    parameter: 'format',
                    value: format
                }
            ];
        }
        PJQ.files.queueDownload(PJQ.helpers.urlHelpers.generateEndpoint([
            {
                endpoint: 'proposals',
                value: this.model.id
            },
            {
                endpoint: 'createexport'
            }
        ], params));
    },
    compare: function () {
        new PJQ.views.bidForms.ProposalsCompareModal({
            collection: this.collection.getProposals(this.model.get('bidFormId')),
            compareProposals: [this.model],
            settings: this.options.settings
        });
    },
    edit: function () {
        this.options.isEdit = true;
        this.render();
    },
    deleteProposal: function () {
        if (this.model instanceof PJQ.models.bidForms.Proposal) {
            new PJQ.views.modals.DeleteCancel({
                header: "Confirm Deletion",
                body: "Are you sure you want to delete this proposal?  This will delete all versions of the proposal.",
                onDelete: _.bind(function () {
                    this.model.destroy();
                    this.collection.trigger('change');
                    if (this.options.modal != null) {
                        this.options.modal.removeModal();
                    }
                }, this)
            });
        }
    },
    cancelEdit: function () {
        this.options.isEdit = false;
        this.model.fetch();
        this.render();
    },
    save: function () {
        if (this.saving) {
            return;
        }
        this.saving = true;

        this.model.set('isSubmitted', false);

        let parentModal = this.$el.closest('.modal-dialog'),
            loader = new PJQ.Loader(parentModal ? parentModal : this.$el);
        this.options.isEdit = false;
        this.model.save(null, {
            success: _.bind(function () {
                PJQ.notifications.notify.successNotify({
                    message: 'Proposal saved'
                });
                loader.remove();
                this.render();
                this.saving = false;
            }, this),
            error: _.bind(function () {
                PJQ.notifications.notify.errorNotify({
                    message: 'Proposal could not be saved'
                });
                loader.remove();
                this.saving = false;
            }, this)
        });
    },
    setLocked: function () {
        this.options.isEdit = false;
        this.model.setLocked();
        this.render();
    },
    reject: function () {
        new PJQ.views.bidForms.RejectModal({
            onConfirm: _.bind(function (note) {
                this.options.isEdit = false;
                this.model.reject(note);
                this.render();
            }, this)
        });
    },
    submit: function () {
        if (!this.options.isAdmin && !this.options.settings.get('isAllowLateBids') && PJQ.helpers.dateHelpers.getTimeStats(new Date(this.model.get('dueDate')), new Date()).totalMinutes < -1) {
            this.render();
            return;
        }

        if (this.saving) {
            return;
        }
        this.saving = true;

        let self = this,
            hasError = false;
        if (this.fileUploader && !this.options.isAdmin && this.options.settings.get('isRequireAttachment') && _.size(this.model.attachments) === 0) {
            this.options.hasFileError = true;
            hasError = true;
        } else {
            let deletedCount = 0
            _.each(this.model.attachments.models, function (model) {
                if (model.get('isDeleted')) {
                    deletedCount++
                }
            }, this)
            if (deletedCount === _.size(this.model.attachments) && !this.options.isAdmin && this.options.settings.get('isRequireAttachment')) {
                hasError = true;
                this.options.hasFileError = true;
            } else {
                this.options.hasFileError = false;
            }
        }

        hasError = hasError || null != _.find(_.union(this.model.lineItems.models, this.model.alternates.models), function (item) {
            let value = item.get('answer') != null ? item.get('answer') : item.get('cost'),
                type = item.get('type').toLowerCase(),
                isValid = true;
            if (item.get('isRequired')) {
                switch (type) {
                    case 'date':
                    case 'date/time':
                        if (typeof value === 'object' && value != null) {
                            value = value.toDateString();
                        }
                        isValid = value != null && _.size(value) > 0;
                        break;
                    default:
                        isValid = typeof value === 'number' ? _.size(value.toString()) !== 0 : value != null && _.size(value) > 0;
                }
            }

            return !isValid;
        }, this);

        hasError = hasError || null != _.find(_.union(this.model.acknowledgements.models, this.projectBidForm.acknowledgements.models, this.projectBidForm.bonding.models, this.projectBidForm.certifications.models, this.projectBidForm.laborRates.models), function (item) {
            let value = item.get('value'),
                type = item.get('type').toLowerCase(),
                isValid = true;
            if (item.get('isRequired')) {
                switch (type) {
                    case 'date':
                    case 'date/time':
                        if (typeof value === 'object' && value != null) {
                            value = value.toDateString();
                        }
                        isValid = value != null && _.size(value) > 0;
                        break;
                    default:
                        isValid = typeof value === 'number' ? _.size(value.toString()) !== 0 : value != null && _.size(value) > 0;
                }
            }
            return !isValid;
        }, this);

        if (hasError) {
            this.options.isShowErrors = true;
            this.options.isEdit = true;
            this.render();
            this.saving = false;
        } else {
            if (this.fileUploader) {
                this.fileUploader.clearError();
            }
            new PJQ.views.BaseModal({
                header: "Confirm Submission",
                body: "Are you sure you want to submit this bid?",
                isShowCancelButton: true,
                okButtonText: "Confirm",
                onOk: () => {
                    if (this.isSubmitting) {
                        return;
                    }
                    this.isSubmitting = true;

                    let loader = new PJQ.Loader(this.$el);
                    this.options.isEdit = false;
                    this.model.submit(true, () => {
                        this.render();
                        loader.remove();
                        this.saving = false;
                        this.isSubmitting = false;
                    });
                },
                onClose: () => {
                    this.saving = false;
                }
            });
        }
    },
    unaward: function () {
        new PJQ.views.BaseModal({
            header: "Confirm Award",
            body: "Are you sure you want to unaward this bid?",
            isShowCancelButton: true,
            okButtonText: "Confirm",
            onOk: _.bind(function () {
                this.options.isEdit = false;
                this.model.award(false);
                this.render();
            }, this)
        });
    },
    award: function () {
        new PJQ.views.BaseModal({
            header: "Confirm Award",
            body: "Are you sure you want to award this bid?",
            isShowCancelButton: true,
            okButtonText: "Confirm",
            onOk: _.bind(function () {
                this.options.isEdit = false;
                this.model.award(true);
                this.render();
            }, this)
        });
    }
});

PJQ.views.bidForms.BidFormViewerSelectorModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Viewer-Selector'),
    },
    afterRender: function () {
        new PJQ.views.bidForms.BidFormViewerSelector({
            el: this.$('.bid-form-selector'),
            model: this.model
        });
    }
});

PJQ.views.bidForms.BidFormViewerSelector = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Viewer-Selector'),
    },
    events: {
        "click .bid-form-view-button": "viewBidForm"
    },
    beforeFirstRender: function () {
        this.listenTo(this.model, "sync", this.render);
        PJQ.app.session.project.fetchBidFormSettings(_.bind(function (settings) {
            this.options.settings = settings;
            this.model.fetch();
        }, this));
    },
    beforeRender: function () {
        if (this.model.isFetched && _.size(this.model) === 0) {
            new PJQ.views.groups.SelectGroupsModal({
                alert: "We don't have any trades saved for you.  Please select those that you plan to bid.",
                selectorOptions: {
                    groupUserId: PJQ.app.session.project.get('masterUserId')
                },
                onSave: _.bind(function (data) {
                    new PJQ.ajax.Request({
                        endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                            {
                                endpoint: 'projects',
                                value: PJQ.app.session.project.id
                            },
                            {
                                endpoint: 'contacts',
                                value: PJQ.app.session.contact.id
                            },
                            {
                                endpoint: 'groups'
                            }
                        ]),
                        data: data.selected
                    }).put().done(_.bind(function () {
                        this.model.fetch();
                    }, this));
                }, this)
            });
        }

        this.renderData = {
            models: this.model.proposals.models
        };
    },
    afterRender: function () {
        this.renderBidForms();
    },
    renderBidForms: function () {
        _.each(this.model.proposals.models, function (model) {
            this.renderBidForm(model);
        }, this);
    },
    renderBidForm: function (model) {
        new PJQ.views.bidForms.BidFormViewer({
            el: this.$('#bid-form-accordion').find('div[data-groupid="' + model.get('group').groupId + '"]'),
            model: model,
            projectBidForm: model.projectProposal,
            settings: this.options.settings,
            isEdit: !model.get('isSubmitted')
        });
    },
    viewBidForm: function (e) {
        let target = $(e.currentTarget),
            proposal = this.model.proposals.get(target.data('cid'));

        if (target.hasClass('btn-primary')) {
            let self = this;
            this.$('.bid-form-view-button').each(function () {
                let thisProposal = self.model.proposals.models.get($(this).data('cid'));
                $(this).text(thisProposal.id > 0 ? "Continue" : "Start").removeClass('btn-secondary').addClass('btn-primary');
            });
            target.addClass('btn-secondary');
            target.removeClass('btn-primary');
            target.text("Close");
        } else {
            target.addClass('btn-primary');
            target.removeClass('btn-secondary');
            target.text(proposal.id > 0 ? "Continue" : "Start");
        }
    }
});

PJQ.views.bidForms.ProposalSelector = PJQ.views.BaseView.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal-Selector'),
    },
    events: {
        "click .proposal-edit-button": "editProposal",
        "click .proposal-review-button": "viewProposal"
    },
    beforeFirstRender: function () {
        this.listenTo(this.model, "sync", this.render);
        this.listenTo(this.model.proposals, 'update fetch sync', this.render);
        PJQ.app.session.project.fetchBidFormSettings(_.bind(function (settings) {
            this.options.settings = settings;
            this.model.fetch();
        }, this));
    },
    beforeRender: function () {
        if (!this.options.noGroups && (this.model.isFetched && _.size(this.model.proposals.models) === 0)) {
            let fnSelector = _.bind(function (groups) {
                new PJQ.views.groups.SelectGroupsModal({
                    alert: "We don't have any trades saved for you.  Please select those that you plan to bid.",
                    selectorOptions: {
                        groups: groups != null ? groups.models : null,
                        groupUserId: PJQ.app.session.project.get('masterUserId')
                    },
                    onSave: _.bind(function (data) {
                        new PJQ.ajax.Request({
                            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                                {
                                    endpoint: 'projects',
                                    value: PJQ.app.session.project.id
                                },
                                {
                                    endpoint: 'contacts',
                                    value: PJQ.app.session.contact.id
                                },
                                {
                                    endpoint: 'groups'
                                }
                            ]),
                            data: data.selected
                        }).put().done(_.bind(function () {
                            this.model.fetch();
                        }, this));
                    }, this)
                });
            }, this);
            if (PJQ.app.session.project.preferences.hasPref(PJQ.constants.preferenceTypes.PROJECT_MESSAGING_RESTRICT_TO_EXISTING_GROUPS)) {
                PJQ.app.session.project.fetchGroups(_.bind(function (groups) {
                    if (_.size(groups.models) === 0) {
                        this.options.noGroups = true;
                        this.render();
                        return;
                    }
                    fnSelector(groups);
                }, this));
            } else {
                fnSelector();
            }
        }
    },
    renderData: function () {
        return {
            options: this.options,
            models: this.model.proposals.models,
            settings: this.options.settings
        };
    },
    viewProposal: function (e) {
        let cid = $(e.currentTarget).closest('.proposal-outer').data('cid'),
            proposal = this.model.proposals.get(cid);
        new PJQ.views.bidForms.BidFormPreviewModal({
            model: proposal,
            projectBidForm: proposal.projectProposal,
            settings: this.options.settings
        });
    },
    editProposal: function (e) {
        let cid = $(e.currentTarget).closest('.proposal-outer').data('cid'),
            proposal = this.model.proposals.get(cid);
        new PJQ.views.bidForms.BidFormPreviewModal({
            model: proposal,
            projectBidForm: proposal.projectProposal,
            settings: this.options.settings,
            isEdit: true
        });
    }
});

PJQ.views.bidForms.ProposalItemEditModal = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Modal-Proposal-Item-Edit'),
        subTemplates: {
            comments: new PJQ.templating.Template(PJQ.constants.modules.BIDFORMS, 'Proposal-Line-Item-Comments')
        },
        minWidth: '400px',
        onSave: _.noop,
        item: null
    },
    events: {
        'keyup .comment': 'commentChanged',
        'click .comment-add': 'commentAdded',
        'click .comment-delete': 'commentDeleted',
        'click .save-details': 'saveDetails'
    },
    beforeModalCreated: function () {
        if (this.options.item instanceof PJQ.models.bidForms.ProposalLineItem) {
            this.options.parentIdField = 'proposalLineItemId';
            this.options.commentIdField = 'proposalLineItemCommentId';
            this.options.CommentModel = PJQ.models.bidForms.ProposalLineItemComment;
        } else if (this.options.item instanceof PJQ.models.bidForms.Alternate) {
            this.options.parentIdField = 'proposalAlternateId';
            this.options.commentIdField = 'proposalAlternateCommentId';
            this.options.CommentModel = PJQ.models.bidForms.ProposalAlternateComment;
        }
    },
    beforeRender: function () {
        this.renderData = {
            item: this.options.item,
            comments: this.options.item.comments,
            canViewComments: PJQ.app.session.project.hasPermission('bidForms.canViewComments'),
            canAddComments: PJQ.app.session.project.hasPermission('bidForms.canAddComments'),
            commentIdField: this.options.commentIdField
        };
    },
    afterRender: function () {
        this.$('.comment-add').prop('disabled', true);

        if (PJQ.app.session.project.hasPermission('bidForms.canViewComments'))
            this.renderComments();

        this.$('.comment').focus();
    },
    renderComments: function () {
        let comments = _.filter(this.options.item.comments.models, function (comment) {
            return !comment.get('isDeleted');
        });
        if (_.size(comments) == 0) {
            this.$('.comments-header, .comments-list').addClass('hidden');
        } else {
            this.$('.comments-list').html('');
            this.$('.comments-header, .comments-list').removeClass('hidden');
            this.renderSubTemplate(true, this.options.subTemplates.comments, this.$('.comments-list'), {
                comments: this.options.item.comments,
                canDeleteComments: PJQ.app.session.project.hasPermission('bidForms.canDeleteComments'),
                commentIdField: this.options.commentIdField
            }, _.bind(function ($el) {
                // todo: bind delete button
                /*
                $el.find('.comment-delete').off('click').on('click', _.bind(function(event) {
                    console.log($(event.currentTarget).data('commentCid'));
                }, this));

                 */
            }, this));
        }
    },
    saveDetails: function () {
        if (typeof this.options.onSave == 'function')
            this.options.onSave();

        this.removeModal();
    },
    commentAdded: function () {
        let comment = new this.options.CommentModel();
        comment.set('proposalId', this.options.item.get('proposalId'));
        comment.set(this.options.parentIdField, this.options.item.get(this.options.parentIdField));
        comment.set('comment', this.$('.comment').val());
        comment.set('createdBy', PJQ.app.session.contact != null ? PJQ.app.session.contact.id : -PJQ.app.session.user.id);
        comment.set('createdByDisplay', PJQ.app.session.contact != null ? PJQ.app.session.contact.get('companyName') : PJQ.app.session.user.get('contactName'));
        comment.set('createdOn', new Date().toISOString());

        this.options.item.comments.add(comment);
        this.$('.comment').val('');
        this.$('.comment-add').prop('disabled', true);
        this.renderComments();
    },
    commentDeleted: function (sender) {
        this.selectedCard = this.$(sender.currentTarget).closest('div.card');

        new PJQ.views.BaseModal({
            header: "Delete Comment",
            body: "Are you sure you want to delete this comment?",
            isShowCancelButton: true,
            onOk: _.bind(function () {
                let commentCid = this.selectedCard.data('commentCid'),
                    comment = this.options.item.comments.get({cid: commentCid});

                if (comment.get(this.options.commentIdField) > 0)
                    comment.set('isDeleted', true);
                else
                    comment.destroy();

                this.renderComments();

            }, this)
        });

    },
    commentChanged: function () {
        this.$('.comment-add').prop('disabled', _.size(this.$('.comment').val()) === 0);
    }
});
